import { energyIntakeDraft } from "./energy-intake"
import { boolLabel, fmtDate } from "./benefit-format"
import type { BenefitDetailDto } from "./benefit-types"

/** Read the same saved inputs as the energy editor. Do not merge conflicting program facts,
 * infer a program from a grant/request, or turn unanswered values into zero/No.
 */
export function householdEnergyFacts(benefit: BenefitDetailDto) {
  const saved = energyIntakeDraft(benefit, [])
  const programs = [
    ...(saved.liheapEnabled ? [{ name: "LIHEAP", facts: saved.liheap }] : []),
    ...(saved.sheapEnabled ? [{ name: "SHEAP", facts: saved.sheap }] : []),
  ]
  const rows = (label: string, value: (facts: Pick<typeof saved.sheap, "numberOfBedrooms" | "heatWithRent" | "conservationEducation">) => string): [string, string][] =>
    programs.length ? programs.map(program => [ `${label} (${program.name})`, value(program.facts) ]) : [[label, "—"]]
  return {
    bedrooms: rows("Bedrooms", facts => facts.numberOfBedrooms || "—"),
    heat: rows("Heat included in rent", facts => boolLabel(facts.heatWithRent)),
    education: rows("Conservation education", facts => boolLabel(facts.conservationEducation)),
    moveInDate: fmtDate(saved.pse.dateMovedInResidence),
  }
}
